<script setup>
	// app.vue 或项目入口文件
	import {
		onLaunch
	} from '@dcloudio/uni-app'
	import {
		useUserStore
	} from '@/stores/user'

	const userStore = useUserStore()
	onLaunch(() => {
		userStore.reStartRefresh()
	})
</script>

<style lang="scss">
	@import "uview-plus/index.scss";
	@import "/static/styles/app.scss";
</style>